import { Component, Input, OnInit } from '@angular/core';
import { ProductItems } from '../../../../../../models/product/get-product-request';

@Component({
  selector: 'product-uom-view',
  templateUrl: './product-uom-view.component.html',
  styleUrls: ['./product-uom-view.component.scss'],
})
export class ProductUomViewComponent implements OnInit {
  @Input() productItem: ProductItems | null = null;

  constructor() {}

  ngOnInit(): void {}

  get uomCategory(): string {
    // ProductItems doesn't have UOMCategoryName, using placeholder
    return 'Weight';
  }

  get measurement(): string {
    return this.productItem?.UOM || 'Not specified';
  }

  get units(): string {
    if (!this.productItem?.Units) {
      return 'Not specified';
    }
    return this.productItem.Units.toString();
  }

  get isWeightVolumeBased(): boolean {
    return this.uomCategory !== 'Units' && this.uomCategory !== 'Not specified';
  }

  getUOMCategoryIcon(): string {
    switch (this.uomCategory.toLowerCase()) {
      case 'weight':
        return 'scale';
      case 'volume':
        return 'local_drink';
      case 'length':
        return 'straighten';
      case 'units':
        return 'inventory';
      default:
        return 'category';
    }
  }
}
